import * as React from 'react';
import { RoundButton } from '@cian/ui-kit';
import { IconFunctionalLock16 } from '@cian/ui-kit-design-tokens/icons';

export interface IPinButtonProps {
  active: boolean;
  onClick: () => void;
}

export const PinButton: React.FC<IPinButtonProps> = ({ active, onClick }) => (
  <RoundButton
    data-testid="newbuilding-pin-button"
    icon={
      <div>
        <IconFunctionalLock16 color={active ? 'icon-main-default' : undefined} />
      </div>
    }
    onClick={onClick}
    size="M"
    theme="light"
    title="Закрепить колонку"
  />
);
